import OntruckShipperOrderFormWrapper from './Wrapper';
import IntraserShipperOrderFormWrapper from './Intraser/TenantWrapper';
import OntruckShipperOrderForm from './Form';
import IntraserShipperOrderForm from './Intraser/Form';
import { TENANTS_NAMES } from 'tenant/host_config';
import { getTenantPreLoginConfig } from 'tenant/teanantPreLoginConfig';

const formConfig = getTenantPreLoginConfig().create_order_form;
const ShipperOrderFormWrapper = (props) => {
  const FormWrapers = {
    [TENANTS_NAMES.ontruck]: OntruckShipperOrderFormWrapper,
    [TENANTS_NAMES.intraser]: IntraserShipperOrderFormWrapper,
  };
  const FormWraper = FormWrapers[formConfig] || <></>;

  return <FormWraper {...props} />;
};

const ShipperOrderForm = (props) => {
  const Forms = {
    [TENANTS_NAMES.ontruck]: OntruckShipperOrderForm,
    [TENANTS_NAMES.intraser]: IntraserShipperOrderForm,
  };
  const FormComponent = Forms[formConfig] || <></>;

  return <FormComponent {...props} />;
};
export { ShipperOrderFormWrapper, ShipperOrderForm };
